<template>
    <v-card class="patient fill-height">
        <v-container>
            <v-form ref="doctorForm" v-model="doctorInfoValid" lazy-validation>

            <v-layout>
                <v-flex md10 offset-md1>
                    <h3 class="headline mb-4">Informations du médecin</h3>

                    <v-text-field v-model="name" :rules="nameRules" label="Nom" required></v-text-field>

                    <v-text-field :rules="emailRules"
                                  :value="email ? email.toLowerCase() : ''"
                                  @input="(value) => { setEmail(value.toLowerCase()) }"
                                  label="Email"></v-text-field>

                    <v-text-field v-model="phone" label="Téléphone"></v-text-field>


                    <v-text-field v-model="address" label="Adresse"></v-text-field>
                    <v-text-field v-model="postcode" label="Code postal"></v-text-field>
                    <v-text-field v-model="city" label="Ville"></v-text-field>
                    <v-select
                        :items="countryList"
                        v-model="country" label="Pays"
                        item-text="name"
                        item-value="name"
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex md10 offset-md1 text-xs-right>
                    <v-btn :disabled="!doctorInfoValid" color="success" @click="validate">Enregistrer
                    </v-btn>

                    <v-btn color="danger" flat @click="deleteDialog = true">
                        <v-icon>delete</v-icon> Supprimer
                    </v-btn>
                </v-flex>
            </v-layout>

        </v-form>

            <v-dialog v-model="deleteDialog" persistent max-width="480">
                <v-card>
                    <v-card-title class="headline">Supprimer le médecin</v-card-title>
                    <v-card-text>Voulez-vous vraiment supprimer le médecin ?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" text @click="deleteDialog = false">Annuler</v-btn>
                        <v-btn color="primary" text @click="deleteDoctor()">Oui, supprimer</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-container>
    </v-card>

</template>

<script>
import {mapActions, mapState, mapMutations, mapGetters} from 'vuex'
    import {getTranslationString} from "../../helper"
    import countries from "../../countries"

    export default {
        name: "DoctorForm",
        data() {
            return {
                mode: 'create',
                doctorInfoValid: false,
                nameRules: [
                    v => !!v || 'Le nom est requis'
                ],
                emailRules: [
                    v => (!v || (/.+@.+\..+/.test(v))) || 'E-mail must be valid'
                ],
                deleteDialog: false
            }
        },
        computed: {
            countryList() {
                return countries
            },
            ...mapState('doctors', {
                doctorsList: state => state.doctorsList
            }),
            name: {
                get() {
                    return this.$store.state.doctors.form.name
                },
                set(value) {
                    this.setName(value)
                }
            },
            email: {
                get() {
                    return this.$store.state.doctors.form.email
                },
                set(value) {
                    this.setEmail(value)
                }
            },
            phone: {
                get() {
                    return this.$store.state.doctors.form.phone
                },
                set(value) {
                    this.setPhone(value)
                }
            },
            address: {
                get() {
                    return this.$store.state.doctors.form.address
                },
                set(value) {
                    this.setAddress(value)
                }
            },
            postcode: {
                get() {
                    return this.$store.state.doctors.form.postcode
                },
                set(value) {
                    this.setPostcode(value)
                }
            },
            city: {
                get() {
                    return this.$store.state.doctors.form.city
                },
                set(value) {
                    this.setCity(value)
                }
            },
            country: {
                get() {
                    return this.$store.state.doctors.form.country
                },
                set(value) {
                    this.setCountry(value)
                }
            },
        },
        created() {
            if (this.$route.params.id) {
                this.mode = "edit"

                this.setSelectedDoctorId(this.$route.params.id)
                this.loadDoctorForm()
            }
            else {
                this.mode = "create"
            }
        },
        mounted() {
            if (this.mode === 'create') {
                this.name = ''
                this.email = ''
                this.phone = ''
                this.address = ''
                this.postcode = ''
                this.city = ''
                this.country = 'Suisse'
            }
        },
        methods: {
            validate() {
                if (this.$refs.doctorForm.validate()) {
                    this.submit()
                }
            },
            submit() {
                if (this.mode === 'create') {
                    this.createDoctor().then(response => {
                        this.$router.replace({name: 'doctors'})
                    }).catch(reason => {
                        //Stay here..
                    })
                } else {
                    this.updateDoctor().then(response => {
                        this.$router.replace({name: 'doctors'})
                    }).catch(reason => {
                        //Stay here..
                    })
                }
            },
            deleteDoctor() {
                this.postDeleteDoctor().then(response => {
                    this.$router.replace({name: 'doctors'})
                }).catch(reason => {
                    //Stay here..
                })
            },
            ...mapMutations('doctors', {
                setName: 'setFormName',
                setEmail: 'setFormEmail',
                setPhone: 'setFormPhone',
                setAddress: 'setFormAddress',
                setPostcode: 'setFormPostcode',
                setCity: 'setFormCity',
                setCountry: 'setFormCountry',
                setSelectedDoctorId: 'setSelectedDoctorId',
                initDoctorForms: 'initDoctorForms',
            }),
            ...mapActions('doctors', ['createDoctor', 'updateDoctor', 'loadDoctorForm', 'postDeleteDoctor'])
        },
        watch: {
        },
    }
</script>

<style scoped>

</style>
